import React from "react";
import { ResetPassword } from "../../components/ResetPassword/ResetPassword";

const ResetPasswordPage = (): React.ReactElement => <ResetPassword />;

export default ResetPasswordPage;
